import React, { Component } from 'react'
import AnimatedNumber from 'react-animated-number'

let value = 52107181855

export default class NumberCounter extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  round(value) {
    if (value) {
      return parseFloat(Math.round((value / 1000000) * 100) / 100).toFixed(2)
    }
    return 0
  }

  addCommas(nStr, pre = 0) {
    nStr += ''
    let x = nStr.split('.')
    let x1 = x[0]
    let x2 = x.length > 1 ? '.' + x[1].substring(0, 2) : ''
    let rgx = /(\d+)(\d{3})/
    let plusMinus = ''
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + "'" + '$2')
    }
    if (pre === 1) {
      plusMinus = nStr > 0 ? '+' : ''
    }
    return plusMinus + x1 + x2
  }

  render() {
    let bgColor = '#e04242'
    let bgColorDiff = '#e04242'

    if (value < this.props.value) {
      bgColor = '#40a740'
    }

    if (this.props.value - this.props.start_value > 0) {
      bgColorDiff = '#40a740'
    }

    value = this.props.value

    return (
      <div className='numberCounter'>
        <h4 style={{ marginBlockEnd: '0' }}>{this.props.title}</h4>
        <h5 className='numberCounterTitle'>
          <AnimatedNumber
            component='text'
            value={this.props.value}
            style={{
              transition: '1s ease-out',
              transitionProperty: 'background-color, color, opacity'
            }}
            frameStyle={perc =>
              perc === 100 ? {} : { backgroundColor: bgColor }
            }
            duration={300}
            formatValue={n =>
              this.addCommas(this.round(n)).replace('.', ',') + ' Mio. Fr.'
            }
          />
        </h5>
        <span>
          Differenz zu realem Steuereinkommen:
          <br />
          <AnimatedNumber
            component='text'
            value={this.props.value - this.props.start_value}
            style={{
              transition: '1s ease-out',
              transitionProperty: 'background-color, color, opacity'
            }}
            frameStyle={perc =>
              perc === 100 ? {} : { backgroundColor: bgColorDiff }
            }
            duration={300}
            formatValue={n =>
              this.addCommas(this.round(n), 1).replace('.', ',') + ' Mio. Fr.'
            }
          />
        </span>
      </div>
    )
  }
}
